'use client'
import { useState, useRef, useEffect } from "react"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

const tours = [
  {
    title: "Tour por Isla Mujeres",
    price: "$55 USD",
    description:
      "Vive una experiencia increíble navegando en catamarán desde Cancún hacia Isla Mujeres. Disfruta 7 horas de aventura con barra libre, snorkel en un arrecife con estatuas submarinas y una deliciosa comida buffet en un club de playa privado. Relájate en camastros, recorre el centro de Isla Mujeres y finaliza el día con la divertida actividad del spinnaker (si el clima lo permite), antes de regresar a Cancún con la mejor vibra a bordo.",
    img: "/Tours/isla-mujeres.jpg",
  },
  {
    title: "Tour por Isla Saona",
    price: "$65 USD",
    description:
      "Visita la icónica Isla Saona con catamarán y lancha rápida. Disfruta aguas turquesa, piscinas naturales con estrellas de mar, playa paradisíaca y buffet típico en un entorno ecológico único.",
    img: "/Tours/isla-saona.jpg",
  },
  {
    title: "Guatapé y El Peñol",
    price: "$45 USD",
    description:
      "Recorrido por El Retiro, réplicas históricas de El Peñol, almuerzo con vistas al embalse, caminata por Guatapé y sus zócalos. Incluye guía, transporte y paradas panorámicas.",
    img: "/Tours/guatape_penol.jpg",
  },
  {
    title: "4 Islas + Plancton en Cartagena",
    price: "$70 USD",
    description:
      "Tour por las Islas del Rosario con snorkel, Cholon, Agua Azul y Playa Tranquila. Almuerzo típico, instalaciones incluidas y actividad nocturna de plancton bioluminiscente.",
    img: "/Tours/cartagena_4_islas.jpg",
  },
  {
    title: "Lo Mejor de Panamá: Canal, Ciudad y Compras",
    price: "$50 USD",
    description:
      "Recorrido por el Casco Antiguo, el Centro de Visitantes de Miraflores para ver el Canal en acción y visita a Albrook Mall para compras. Ideal para descubrir Panamá en un día.",
    img: "/Tours/panama_canal.jpg",
  },
  {
    title: "Hop On Hop Off por Madrid",
    price: "$35 USD",
    description:
      "Explora Madrid a tu ritmo con un autobús turístico de dos pisos. Sube y baja en cualquiera de sus rutas, disfruta audioguía en 14 idiomas y conoce los puntos icónicos de la ciudad.",
    img: "/Tours/madrid_bus.jpg",
  },
  {
    title: "Tour Torre Eiffel + Crucero por el Sena",
    price: "$165 USD",
    description:
      "Recorrido panorámico por París, acceso sin filas a la Torre Eiffel (2° piso) y crucero por el río Sena. Historia, cultura y vistas inolvidables de la Ciudad Luz.",
    img: "/Tours/eiffel_sena.jpg",
  },
  {
    title: "Vive la Magia de Disney World",
    price: "$250 USD",
    description:
      "Descubre los 4 parques temáticos: Magic Kingdom, Epcot, Hollywood Studios y Animal Kingdom. Diversión, atracciones, shows, personajes y toda la magia de Disney.",
    img: "/Tours/disneyworld.jpg",
  },
];

const Tours = () => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % tours.length);
    }, 5000);
    return () => clearTimeout(timeoutRef.current);
  }, [current]);

  const prevSlide = () => setCurrent((current - 1 + tours.length) % tours.length);
  const nextSlide = () => setCurrent((current + 1) % tours.length);

  return (
    <div
      id="tours"
      className="mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8 scroll-mt-28"
    >
      <div className="mx-auto max-w-2xl lg:mx-0">
        <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          ¡Tenemos los mejores precios para las mejores experiencias!
        </h2>

        <p className="mt-6 text-base/7 text-gray-600">
          Descubre los mejores destinos a precios que nadie más puede ofrecer.
          Viaja más, paga menos y vive experiencias inolvidables en cada rincón del mundo.
        </p>
      </div>
      <div className="w-full max-w-7xl mx-auto mt-14">
        <div className="relative overflow-hidden rounded-3xl">
          <div
            className="flex transition-transform duration-700"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {tours.map((tour, index) => (
              <div
                key={index}
                className="min-w-full flex flex-col lg:flex-row bg-white rounded-3xl shadow-xl"
              >
                <img
                  src={tour.img}
                  alt={tour.title}
                  className="w-full lg:w-1/2 h-[350px] lg:h-[500px] object-cover"
                />

                <div className="flex flex-col justify-center p-10 lg:w-1/2">
                  <p className="text-3xl font-bold text-indigo-600">
                    Desde {tour.price}
                  </p>

                  <h3 className="mt-2 text-2xl font-semibold text-gray-900">
                    {tour.title}
                  </h3>

                  <p className="mt-4 text-gray-600">{tour.description}</p>

                  <a
                    href={`https://wa.me/50239990332?text=${encodeURIComponent(
                      `Hola, quiero más información sobre el tour a ${tour.title}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 w-fit px-7 py-3.5 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition"
                  >
                    Reservar ahora
                  </a>
                </div>
              </div>
            ))}
          </div>
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white text-gray-900/50 p-3 rounded-full hover:bg-white/70 transition"
          >
            <ChevronLeftIcon className="w-6 h-6" />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white text-gray-900/50 p-3 rounded-full hover:bg-white/70 transition"
          >
            <ChevronRightIcon className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Tours;
